export const ACCOUNT_LOGIN = "account/login";
export const ACCOUNT_LOGOUT = "account/logout";
export const ACCOUNT_RESET_PASSWORD = "account/resetPassword";
export const SET_CURRENT_LOGIN_ACCOUNT = "account/setCurrentLoginAccount";
export const ACCOUNT_FORGOT_PASSWORD = "account/forgotPassword";
export const ACCOUNT_REGISTER = "account/registerAccount";
export const ACCOUNT_CHANGE_PASSWORD = "account/changePassword";
